module.exports = __webpack_public_path__ + "static/media/image3.8ee5b224.png";